// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import Loading from '../../../_common/Loading';
import Page from '../../pageLayout/Page';
import { QuestRoute } from '../../../_common/api/QuestRoutes';
import ItemList from '../../ItemList';
import { HamQuest } from '../../../../App';

const Washes = () => {
    const [washes, setWashes] = useState(null);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.washes)
            .then((res) => setWashes(res))
    }, [])

    if (!washes) return <Loading />

    return (
        <Page>
            <ItemList items={washes} />
        </Page>
    );
}

export default Washes;